
import { useState } from "react";
import productData from "../data/products.json"
import ProductCardFM from "../components/ProductCardformarketplace";

export const FlipkartPage = () => {  
    const [products] = useState(
    productData.products.filter((product) => product.productstatus === "Active")
  );
  return (
    <div className="">
    <div className="text-center my-4">
        <h2 className="mt-3 text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900">
            Shop Shinzura on Flipkart
        </h2>
    </div>
      <div className="container mx-auto mt-2">
            <section className="py-4 px-2 md:px-8 lg:px-16 bg-white">
                <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-4 md:grid-cols-6 md:gap-4">
                    {products.map((product) => (
                    <div key={product.id} className="sm:mt-8">
                        <ProductCardFM product={product} buylink={product.flipkart} />
                    </div>
                    ))}
                </div>
            </section>
      </div>
    </div>
  );
};